import { Sparkles } from "lucide-react";
import { Heading, Text } from "@/components/Typography";

interface AdvisorMatchingHeaderProps {
  variant?: "page" | "modal";
  description: string;
}

export const AdvisorMatchingHeader = ({
  variant = "page",
  description,
}: AdvisorMatchingHeaderProps) => {
  if (variant === "modal") {
    return (
      <>
        <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary-350 dark:border-pab-dark-pill-border bg-primary-250 dark:bg-surface-card-inner px-3 py-1.5 sm:px-4 sm:py-2">
          <Sparkles className="h-4 w-4 text-goals-purple-selected" />
          <Text as="span" className="text-sm font-medium text-goals-purple-selected">
            AI-Matched Experts
          </Text>
        </div>
        <Heading
          as="h2"
          className="text-[20px] font-semibold leading-7 tracking-[-0.2px] text-secondary-900 dark:text-white pr-10"
        >
          Meet Your Top Expert Matches
        </Heading>
        <Text
          as="p"
          className="mt-1.5 text-[13px] leading-5 text-accent-250 dark:text-pab-dark-subtle-text pr-10"
        >
          {description}
        </Text>
      </>
    );
  }

  return (
    <div className="mb-8 sm:mb-10">
      <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary-350 dark:border-pab-dark-pill-border bg-primary-250 dark:bg-surface-card-inner px-3 py-1.5 sm:px-4 sm:py-2">
        <Sparkles className="h-4 w-4 text-goals-purple-selected" />
        <Text as="span" className="text-sm font-medium text-goals-purple-selected">
          AI-Matched Experts
        </Text>
      </div>
      <Heading
        as="h1"
        className="text-36 font-bold leading-tight text-secondary-900 dark:text-white sm:text-30"
      >
        Meet Your Top Expert Matches
      </Heading>
      <Text
        as="p"
        className="mt-3 max-w-5xl text-18 leading-7 text-ai-goal-back-btn-text font-inter sm:text-18"
      >
        {description}
      </Text>
    </div>
  );
};
